/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandPolymer = createReactComponent("outline", "brand-polymer", "IconBrandPolymer", [["path", { "d": "M6.706 6l-3.706 6l3.706 6h1.059l8.47 -12h1.06l3.705 6l-3.706 6", "key": "svg-0" }]]);

export { IconBrandPolymer as default };
//# sourceMappingURL=IconBrandPolymer.mjs.map
